import { useLocale, useTranslations } from "next-intl";

import { ProfileWrapper } from "@/components/profile/ProfileWrapper";
import { usePathname, useRouter } from "@/i18n/routing";
import { getLocaleOptions } from "@/lib/utils";

export const LocalePreference = () => {
    const t = useTranslations("locale");
    const localeOptions = getLocaleOptions();

    const locale = useLocale();
    const pathname = usePathname();
    const router = useRouter();

    const handleLanguageChange = (newLanguage: string) => {
        router.replace(pathname, { locale: newLanguage });
    };

    return (
        <ProfileWrapper
            headerLabel={ t("applicationLanguage") }
            currentValue={ locale }
            options={ localeOptions }
            onSelect={ handleLanguageChange }
            isDialog={ true }
        />
    );
};